import { endPoints } from "../utils/constanst";
import http from "./http";

const sendDocuments = async(poliza)  => {

    const url = endPoints.documetos(poliza.id); 

    const { file } = poliza;

    const files = [file[0], file[1]];

    http(url).file(files);

}

const sendNotificationRate = async(poliza)  => {

    const send = sendNotification(endPoints.failedRate);

    const data = {
        "nombres": `${poliza.nombres} ${poliza.apellidos}` ,
        "telefonoCelular": poliza.telefonoCelular,
        "email": poliza.email
    }

    return send(data);

}

const sendNotificationPayByPhone = async(poliza)  => {

    const send = sendNotification(endPoints.paybyphonecall);

    const data = {
        "nombres": `${poliza.nombres}` ,
        "apellidos": `${poliza.apellidos}` ,
        "telefonoCelular": poliza.telefonoCelular,
        "email": poliza.email,
        "idPoliza": poliza.id
    }

    return send(data);

}

const sendNotification = uri => async(data)  => {

    const resp = await http(uri).post(data);

    return resp;

}

export { sendNotificationRate, sendNotificationPayByPhone, sendDocuments };